
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Input extends Vue {
  @Prop({ default: 'text' })
  private type!: string;

  @Prop({ default: 'textbox', required: true })
  private id!: string;

  @Prop({ default: 'Enter your text here' })
  private placeholder!: string;

  @Prop({ default: 'Lable', required: true })
  private lable!: string;

  @Prop({ default: 'required' })
  private validation!: string;

  @Prop({ default: 'txtName' })
  private name!: string;

  @Prop({ default: false })
  private isRouteLink!: boolean;

  @Prop({ default: '#' })
  private routeLink!: string;

  @Prop({ default: 'click' })
  private routeLinkText!: string;

  @Prop()
  private classic!: string;
}
